import { css } from "styled-components";
const partnershipsPortaventuraPricesMobileStyles = {
    PriceTopMobile: ()=>css`
		color: ${({ theme  })=>theme.colors.grays.darker};
		text-transform: lowercase;
	`,
    PriceCurrentMobile: ()=>css`
		font-family: ${({ theme  })=>theme.font.family.secondary};
		font-weight: bold;
		color: ${({ theme  })=>theme.colors.grays.darker};
	`
};
export default partnershipsPortaventuraPricesMobileStyles;

//# sourceMappingURL=portaventura.js.map